import { SvgIcon } from '@/components/SvgIcon';
import { CompareTariffRowData } from '../CompareTariffsTable/CompareTariffsTable.constants';
import styles from './CompareTariffsValue.module.sass';

interface CompareTariffsValueProps {
  value: CompareTariffRowData;
}

const CompareTariffsValue = ({ value }: CompareTariffsValueProps) => {
  const renderValueByType = (val: CompareTariffRowData) => {
    if (val === null) {
      return '–';
    }

    if (typeof val === 'boolean') {
      return val ? (
        <SvgIcon name="checkbox" className={styles.checkbox} />
      ) : (
        <SvgIcon name="dismiss" className={styles.dismiss} />
      );
    }

    return val;
  };

  return <div className={styles.value}>{renderValueByType(value)}</div>;
};

export default CompareTariffsValue;
